import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { UserService } from "@estatex/services";
import { Router } from "@angular/router";
import { LoginRequest } from "@estatex/types";

@Component({
    selector: "lib-login",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: "./login.component.html",
    styleUrl: "./login.component.css",
})
export class LoginComponent {
    loginForm = this.fb.group({
        username: this.fb.control("", [Validators.required]),
        password: this.fb.control("", [Validators.required]),
    });

    constructor(private readonly fb: FormBuilder, private readonly userService: UserService, private router: Router) {
        this.userService.removeSessionDetails();
    }

    onLogin(): void {
        if (!this.loginForm.valid) {
            return;
        }
        this.userService.login(this.loginForm.getRawValue() as LoginRequest).subscribe(() => {
            this.router.navigate(["admin"]);
        });
    }

    testGateway(): void {
        this.userService.testGateway().subscribe();
    }
}
